import { Content } from '../models/content';

export const italianContent: Content = {
  translation: {
    title:
      'Operatore di pool di staking Cardano con sede in Europa<br /> progettato e realizzato da <a href="mailto:adapool_charles@pm.me">@Charles</a> e <a href="mailto:adapool_mikael@pm.me">@Mika</a>.',
    whoAreWe: 'Chi siamo?',
    whyJoinUs: 'Perché unirsi a noi?',
    poolDetails: 'Dettagli del pool',
    s1: {
      p1: 'Siamo Charles 😊 e Mika 😉, una partnership di due imprenditori francesi motivati a democratizzare l’uso delle criptovalute.',
      p2: 'Mika, che aiuta le amministrazioni nelle loro trasformazioni digitali, apporta la sua esperienza tecnica e umana. Charles apporta oltre un decennio di esperienza nell’ingegneria del software. Insieme, partecipiamo con entusiasmo allo sviluppo della rete Cardano!',
      p3: 'Siamo coinvolti nelle criptovalute dal 2017, quando abbiamo avuto la possibilità di realizzare un profitto al vertice del mercato. Abbiamo scoperto il progetto Cardano in quel momento e, da allora, lo seguiamo con grande interesse. Il nostro obiettivo con ADA Pool Europe è creare una comunità di persone che condividano i nostri valori, credano in Cardano e alla quale vorremmo offrire una buona esperienza di pooling di capitale.',
      p4: 'Il nostro obiettivo con ADA Pool Europe è creare una comunità di persone che condividano i nostri valori, credano in Cardano e alla quale offriamo una buona esperienza di pooling di capitale.',
    },
    s2: {
      p1: 'Siamo motivati a democratizzare l’uso delle criptovalute.',
      p2: ' infrastruttura ad alta disponibilità',
      p3: ' con commissioni limitate',
      p4: ' aperto al pubblico più vasto possibile',
      p5: ' server dedicati e sicuri',
      p6: 'Il nostro pool di staking Cardano con sede in Europa è dedicato al rafforzamento e alla decentralizzazione della rete Cardano. \n Offriamo uno staking affidabile, sicuro e ad alta disponibilità, basato su due nodi relay e un nodo produttore in centri server di classe enterprise. Il nostro obiettivo è creare una buona esperienza per i partecipanti.',
      p7: 'Poniamo una forte attenzione alle prestazioni e alla sicurezza della nostra infrastruttura di pool. Vorremmo permettere a quante più persone possibile di partecipare all’avventura crypto.',
      p8: 'Mettendo in staking i tuoi ADA nel nostro pool, partecipi al funzionamento della rete Cardano.',
      p9: "✔&nbsp;I tuoi ADA non sono mai bloccati, puoi trasferirli in qualsiasi momento e senza penali&nbsp;;<br><br> ✔&nbsp;I tuoi ADA sono sempre nel tuo portafoglio, rimangono con te. Non puoi perderli con il metodo di 'staking' &nbsp;;<br><br> ✔&nbsp;I tuoi premi vengono reinvestiti automaticamente. Ogni 5 giorni ricevi la tua quota di vincite che viene automaticamente accumulata&nbsp;;<br><br> ✔&nbsp;Puoi iniziare ad accumulare i tuoi ADA, anche se ne hai pochissimi.",
    },
    s3: {
      p1: 'Partecipare alla rete Cardano è facile!<br>Ti basta mettere in staking le tue criptovalute ADA nel nostro pool "adapool-europe".',
      p2: 'L’identificativo da inserire per delegare i tuoi ADA:',
      p3: 'Widget interattivo',
      p4: 'Pledge',
      p5: 'Proprietari:',
      p6: 'Valore:',
      p7: ' Stake',
      p8: 'Delegatori:',
      p9: 'Valore:',
      p10: 'Commissioni',
      p11: 'Commissioni variabili:',
      p12: 'Commissione fissa:',
      p13: 'Prezzo della criptovaluta',
    },
    footer: {
      p1: 'Contattaci',
    },
  },
};
